import React from 'react'

export default function Subject(props) {
  return (
    <>
    <div className='container'>
        <h1 className='my-5 text-center'>{props.title}</h1>
        
        <h2 className='my-3'>Previous year question paper</h2>
        <table className="table">
  <thead>
    <tr>
      <th scope="col">Year</th>
      <th scope="col">Internal</th>
      <th scope="col">Mid-sem</th>
      <th scope="col">End-sem</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">2021</th>
      <td><a href={props.int21} >---</a></td>
      <td><a href={props.mid21}target="Blank">{props.mid}</a></td>
      <td><a href={props.end21}target="Blank">Q. Paper</a></td>
    </tr>
    <tr>
      <th scope="row">2020</th>
      <td><a href={props.int20} >---</a></td>
      <td><a href={props.mid20} >---</a></td>
      <td><a href={props.end20} >---</a></td>
    </tr>
  </tbody>
</table>
<h2 className='my-4'>Recommended book by department</h2>
<h6> <a href={props.book1Link} target="Blank">{props.book1}</a></h6>
<h6> <a href={props.book2Link} target="Blank">{props.book2}</a></h6>
    </div>

    </>
  )
}
